import { render, staticRenderFns } from "./PassthroughContainer.vue?vue&type=template&id=4f1fda42&scoped=true&"
import script from "./PassthroughContainer.vue?vue&type=script&lang=ts&"
export * from "./PassthroughContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1fda42",
  null
  
)

export default component.exports